import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";

import {
  Typography,
  Card,
  Divider,
  Button,
  Modal,
  Tabs,
  Tab,
  Box,
} from "@mui/material";

// FIX: @mui/lab no longer exposes deep import paths like
// "@mui/lab/TabPanel" / "@mui/lab/TabContext" in current versions.
// This was almost certainly your build error:
//   Module not found: Error: Can't resolve '@mui/lab/TabPanel'
// Both must be imported from the package root instead.
import { TabContext, TabPanel } from "@mui/lab";

import { ScrollToTop } from "react-simple-scroll-up";
import YouTubeIcon from "@mui/icons-material/YouTube";

import AppbarHead from "./SubComponents/AppbarHead";
import BannerAll from "./SubComponents/BreadCrumbComponent";
import Footer from "./SubComponents/Footer";

import { Colors, Fonts } from "../constants";

/* =========================================================
   YOUTUBE
========================================================= */

import Y1 from "../images/portfolioPageImages/youtube/Y1.jpg";
import Y2 from "../images/portfolioPageImages/youtube/Y2.jpg";
import Y3 from "../images/portfolioPageImages/youtube/Y3.jpg";
import Y4 from "../images/portfolioPageImages/youtube/Y4.jpg";
import Y5 from "../images/portfolioPageImages/youtube/Y5.jpg";
import Y6 from "../images/portfolioPageImages/youtube/Y6.jpg";
import Y7 from "../images/portfolioPageImages/youtube/Y7.jpg";
import Y8 from "../images/portfolioPageImages/youtube/Y8.jpg";
import Y9 from "../images/portfolioPageImages/youtube/Y9.jpg";

/* =========================================================
   NETCOM SMART CLASS
========================================================= */

import NSC01 from "../images/portfolioPageImages/NSC/NSC01.webp";
import NSC03 from "../images/portfolioPageImages/NSC/NSC03.webp";
import NSC06 from "../images/portfolioPageImages/NSC/NSC06.webp";
import NSC07 from "../images/portfolioPageImages/NSC/NSC07.webp";
import NSC08 from "../images/portfolioPageImages/NSC/NSC08.webp";
import NSC09 from "../images/portfolioPageImages/NSC/NSC09.webp";
import NSC11 from "../images/portfolioPageImages/NSC/NSC11.webp";
import NSC13 from "../images/portfolioPageImages/NSC/NSC13.webp";
import NSC15 from "../images/portfolioPageImages/NSC/NSC15.webp";
import NSC16 from "../images/portfolioPageImages/NSC/NSC16.webp";
import NSC17 from "../images/portfolioPageImages/NSC/NSC17.webp";
import NSC36 from "../images/portfolioPageImages/NSC/NSC36.webp";

/* =========================================================
   KIOSK
========================================================= */

import KIOSK1 from "../images/portfolioPageImages/kioskImage/kiosk1.webp";
import KIOSK2 from "../images/portfolioPageImages/kioskImage/kiosk2.webp";
import KIOSK3 from "../images/portfolioPageImages/kioskImage/kiosk3.webp";
import KIOSK4 from "../images/portfolioPageImages/kioskImage/kiosk4.webp";
import KIOSK5 from "../images/portfolioPageImages/kioskImage/kiosk5.webp";
import KIOSK6 from "../images/portfolioPageImages/kioskImage/kiosk6.webp";
import KIOSK7 from "../images/portfolioPageImages/kioskImage/kiosk7.webp";
import KIOSK8 from "../images/portfolioPageImages/kioskImage/kiosk8.webp";
import KIOSK9 from "../images/portfolioPageImages/kioskImage/kiosk9.webp";

/* =========================================================
   SKILL DEVELOPMENT
========================================================= */

import SKILL1 from "../images/portfolioPageImages/skilldevelopment/skill1.webp";
import SKILL2 from "../images/portfolioPageImages/skilldevelopment/skill2.webp";
import SKILL3 from "../images/portfolioPageImages/skilldevelopment/skill3.webp";
import SKILL4 from "../images/portfolioPageImages/skilldevelopment/skill4.webp";
import SKILL5 from "../images/portfolioPageImages/skilldevelopment/skill5.webp";
import SKILL6 from "../images/portfolioPageImages/skilldevelopment/skill6.webp";
import SKILL7 from "../images/portfolioPageImages/skilldevelopment/skill7.webp";
import SKILL8 from "../images/portfolioPageImages/skilldevelopment/skill8.webp";

/* =========================================================
   DIGITAL CONTENT
========================================================= */

import DG1 from "../images/portfolioPageImages/DigitalContentImage/dg1.webp";
import DG2 from "../images/portfolioPageImages/DigitalContentImage/dg2.webp";
import DG3 from "../images/portfolioPageImages/DigitalContentImage/dg3.webp";
import DG4 from "../images/portfolioPageImages/DigitalContentImage/dg4.webp";
import DG5 from "../images/portfolioPageImages/DigitalContentImage/dg5.webp";
import DG6 from "../images/portfolioPageImages/DigitalContentImage/dg6.webp";

/* =========================================================
   AR / VR

   IMPORTANT:
   Folder = ARVR
   Files = ARVR1.jpeg ... ARVR7.jpeg
========================================================= */

import ARVR1 from "../images/portfolioPageImages/ARVR/ARVR1.jpeg";
import ARVR2 from "../images/portfolioPageImages/ARVR/ARVR2.jpeg";
import ARVR3 from "../images/portfolioPageImages/ARVR/ARVR3.jpeg";
import ARVR4 from "../images/portfolioPageImages/ARVR/ARVR4.jpeg";
import ARVR5 from "../images/portfolioPageImages/ARVR/ARVR5.jpeg";
import ARVR6 from "../images/portfolioPageImages/ARVR/ARVR6.jpeg";
import ARVR7 from "../images/portfolioPageImages/ARVR/ARVR7.jpeg";


/* =========================================================
   PORTFOLIO
========================================================= */

export default function Portfolio() {

  /* =======================================================
     STATES
  ======================================================= */

  const [value, setValue] = useState("1");

  const [selectedImg, setSelectedImg] = useState("");

  const [open, setOpen] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);


  /* =======================================================
     STYLES
  ======================================================= */

  const Root = styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "30px",
    width: "90%",
    margin: "auto",

    "@media (max-width: 900px)": {
      width: "100%",
      padding: "10px",
    },
  });


  const GalleryRoot = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%",
    margin: "auto",
  });


  // FIX: card width/height were fixed pixel values with only a single
  // breakpoint. Added an intermediate tablet breakpoint and made the
  // image height responsive (via the img style below) instead of
  // locking it to 300px on every screen size.
  const GalleryCard = styled(Card)({
    margin: "15px",
    width: "350px",
    height: "300px",
    overflow: "hidden",
    cursor: "pointer",
    borderRadius: "10px",
    transition: "0.5s",

    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow:
        "rgba(17,101,48,0.4) 5px 5px, rgba(17,101,48,0.3) 10px 10px, rgba(17,101,48,0.2) 15px 15px",
    },

    "@media (max-width: 900px)": {
      width: "45%",
      height: "260px",
      margin: "10px",
    },

    "@media (max-width: 600px)": {
      width: "95%",
      height: "220px",
      margin: "10px auto",
    },
  });


  // FIX: YouTube cards previously had no responsive styling at all
  // (fixed 350px width). Reusing a styled component fixes that.
  const YouTubeCard = styled(Card)({
    width: "350px",
    margin: "15px",
    borderRadius: "15px",
    overflow: "hidden",

    "@media (max-width: 900px)": {
      width: "45%",
      margin: "10px",
    },

    "@media (max-width: 600px)": {
      width: "95%",
      margin: "10px auto",
    },
  });


  const ModalRoot = styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFF8F3",
    width: "50%",
    maxHeight: "90vh",
    overflow: "hidden",

    "@media (max-width: 900px)": {
      width: "90%",
    },

    "@media (max-width: 600px)": {
      width: "95%",
    },
  });


  /* =======================================================
     YOUTUBE DATA
  ======================================================= */

  const imageName = [
    {
      name: "புகைவண்டி",
      imgLink: Y1,
      videoLink: "https://www.youtube.com/watch?v=Uz98TQd1U_s",
    },
    {
      name: "Adventures of Tenaliraman",
      imgLink: Y2,
      videoLink: "https://www.youtube.com/watch?v=elpnngb_-NM",
    },
    {
      name: "Adventures of Vikramadhityan",
      imgLink: Y3,
      videoLink: "https://www.youtube.com/watch?v=0u9WoKh2auI&t=342s",
    },
    {
      name: "சிட்டு",
      imgLink: Y4,
      videoLink: "https://youtu.be/Vmq9CDAMjVk?t=113",
    },
    {
      name: "Moral Stories",
      imgLink: Y5,
      videoLink: "https://www.youtube.com/watch?v=XEA_ruJZxIE",
    },
    {
      name: "பச்சை கிளி",
      imgLink: Y6,
      videoLink: "https://youtu.be/Uz98TQd1U_s?t=63",
    },
    {
      name: "ஆணை",
      imgLink: Y7,
      videoLink: "https://youtu.be/Uz98TQd1U_s?t=125",
    },
    {
      name: "வீரன்",
      imgLink: Y8,
      videoLink: "https://youtu.be/Uz98TQd1U_s",
    },
    {
      name: "குள்ள வாத்து",
      imgLink: Y9,
      videoLink: "https://youtu.be/Vmq9CDAMjVk",
    },
  ];


  /* =======================================================
     SMART CLASS DATA
  ======================================================= */

  const smartClassRoom = [
    { img: NSC01, text: "ADW 100 School" },
    { img: NSC03, text: "ADW 100 School" },
    { img: NSC06, text: "Dharmapuri-Sitheri School" },
    { img: NSC07, text: "Dharmapuri-Sitheri School" },
    { img: NSC08, text: "Erode-Kongadai School" },
    { img: NSC09, text: "GTR School" },
    { img: NSC11, text: "GTR School Training-Sankarapuram" },
    { img: NSC13, text: "Salem-Kunnur School" },
    { img: NSC15, text: "Sevvapet Girls School" },
    { img: NSC16, text: "Thanjavur-Nalladai" },
    { img: NSC17, text: "Thanjavur-Nalladai" },
    { img: NSC36, text: "Villupuram Sangarapuram School" },
  ];


  /* =======================================================
     KIOSK DATA
  ======================================================= */

  const kioskImage = [
    { img: KIOSK1, text: "Salem-Kunnur School" },
    { img: KIOSK2, text: "Thanjavur-Nalladai" },
    { img: KIOSK3, text: "Villupuram-Sankarapuram School" },
    { img: KIOSK4, text: "GTR School" },
    { img: KIOSK5, text: "Erode-Kongadai School" },
    { img: KIOSK6, text: "Dharmapuri-Sitheri School" },
    { img: KIOSK7, text: "Covai-Muttathuvayal School" },
    { img: KIOSK8, text: "Sevvapet Girls School" },
    { img: KIOSK9, text: "ADW 100 School" },
  ];


  /* =======================================================
     SKILL DEVELOPMENT DATA
  ======================================================= */

  const skilldevelopmentImage = [
    { img: SKILL1, text: "Salem-Kunnur School" },
    { img: SKILL2, text: "Covai-Muttathuvayal School" },
    { img: SKILL3, text: "ADW 100 School" },
    { img: SKILL4, text: "Villupuram-Sankarapuram School" },
    { img: SKILL5, text: "Thanjavur-Nalladai" },
    { img: SKILL6, text: "Sevvapet Girls School" },
    { img: SKILL7, text: "Erode-Kongadai School" },
    { img: SKILL8, text: "GTR School" },
  ];


  /* =======================================================
     DIGITAL CONTENT DATA
  ======================================================= */

  const digitalContent = [
    { img: DG1, text: "Sevvapet Girls School" },
    { img: DG2, text: "Erode-Kongadai School" },
    { img: DG3, text: "Villupuram-Sankarapuram School" },
    { img: DG4, text: "Salem-Kunnur School" },
    { img: DG5, text: "Thanjavur-Nalladai" },
    { img: DG6, text: "GTR School" },
  ];


  /* =======================================================
     AR / VR DATA
  ======================================================= */

  const ARVR = [
    { img: ARVR1, text: "Salem-Kunnur School" },
    { img: ARVR2, text: "Covai-Muttathuvayal School" },
    { img: ARVR3, text: "ADW 100 School" },
    { img: ARVR4, text: "Villupuram-Sankarapuram School" },
    { img: ARVR5, text: "Thanjavur-Nalladai" },
    { img: ARVR6, text: "Sevvapet Girls School" },
    { img: ARVR7, text: "Erode-Kongadai School" },
  ];


  /* =======================================================
     MODAL
  ======================================================= */

  const handleOpen = (data) => {
    setSelectedImg(data.img);
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false);
    setSelectedImg("");
  };


  /* =======================================================
     TAB CHANGE
  ======================================================= */

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  /* =======================================================
     WINDOW RESIZE
  ======================================================= */

  useEffect(() => {

    const updateWidthAndHeight = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWidthAndHeight);

    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener("resize", updateWidthAndHeight);
    };

  }, []);


  /* =======================================================
     GALLERY COMPONENT
  ======================================================= */

  const Gallery = ({ data }) => {

    return (
      <GalleryRoot>

        {data.map((item, index) => (

          <GalleryCard
            key={index}
            onClick={() => handleOpen(item)}
          >

            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >

              {/* FIX: height locked to "100%" instead of the old
                  hardcoded 300px, so it follows GalleryCard's
                  responsive height set via media queries above. */}
              <img
                src={item.img}
                alt={item.text}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />

              <Typography
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: "12px",
                  color: "white",
                  backgroundColor: "rgba(0,0,0,0.55)",
                  textAlign: "center",
                  fontFamily: Fonts.MAIN_FONT,
                  fontSize: { xs: "0.85rem", sm: "1rem" },
                }}
              >
                {item.text}
              </Typography>

            </div>

          </GalleryCard>

        ))}

      </GalleryRoot>
    );
  };


  /* =======================================================
     MAIN RETURN
  ======================================================= */

  return (

    <div>

      <ScrollToTop
        bgColor="green"
        symbol="↑"
        strokeFillColor="white"
      />


      {/* HEADER */}

      <AppbarHead
        dataParent={{
          appBtnText: "Portfolio",
        }}
      />


      {/* BREADCRUMB */}

      <BannerAll
        dataParent={{
          title: "Portfolio",
          subTitle: "We devote all of our experience and efforts for creation",
          path: ["Home", "Portfolio"],
        }}
      />


      {/* MAIN */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >

        <Divider
          style={{
            marginTop: "2%",
            width: "100%",
          }}
        />


        <Box
          sx={{
            width: "100%",
            typography: "body1",
          }}
        >

          <TabContext value={value}>


            {/* =================================================
                TAB BUTTONS
            ================================================= */}

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                px: { xs: 1, sm: 2 },
              }}
            >

              <Tabs
                value={value}
                variant="scrollable"
                allowScrollButtonsMobile
                scrollButtons="auto"
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { background: "green" },
                }}
                textColor="inherit"
                sx={{
                  width: "100%",
                  maxWidth: "1200px",
                }}
              >

                {/* 1 - YouTube */}
                <Tab
                  value="1"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      YouTube
                    </Typography>
                  }
                />

                {/* 2 - Smart Class */}
                <Tab
                  value="2"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      Netcom Smart Class
                    </Typography>
                  }
                />

                {/* 3 - Kiosk */}
                <Tab
                  value="3"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      Kiosk
                    </Typography>
                  }
                />

                {/* 4 - Skill Development */}
                <Tab
                  value="4"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      Skill Development
                    </Typography>
                  }
                />

                {/* 5 - Digital Content */}
                <Tab
                  value="5"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      Netcom Digital Content
                    </Typography>
                  }
                />

                {/* 6 - AR & VR */}
                <Tab
                  value="6"
                  label={
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: Fonts.MAIN_FONT,
                        fontSize: { xs: "0.95rem", sm: "1.25rem" },
                      }}
                    >
                      AR&VR
                    </Typography>
                  }
                />

              </Tabs>

            </Box>


            {/* =================================================
                TAB 1 - YOUTUBE
            ================================================= */}

            <TabPanel value="1">

              <Root>

                {imageName.map((item, index) => (

                  <YouTubeCard key={index}>

                    <img
                      src={item.imgLink}
                      alt={item.name}
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                      }}
                    />

                    <div
                      style={{
                        padding: "15px",
                        textAlign: "center",
                      }}
                    >

                      <Typography
                        style={{
                          fontFamily: Fonts.MAIN_FONT,
                          marginBottom: "10px",
                        }}
                      >
                        {item.name}
                      </Typography>


                      <Button
                        variant="contained"
                        fullWidth
                        startIcon={<YouTubeIcon />}
                        style={{
                          backgroundColor: "#c4302b",
                          textTransform: "capitalize",
                        }}
                        onClick={() =>
                          window.open(item.videoLink, "_blank")
                        }
                      >
                        Visit
                      </Button>

                    </div>

                  </YouTubeCard>

                ))}

              </Root>

            </TabPanel>


            {/* =================================================
                TAB 2 - SMART CLASS
            ================================================= */}

            <TabPanel value="2">
              <Gallery data={smartClassRoom} />
            </TabPanel>


            {/* =================================================
                TAB 3 - KIOSK
            ================================================= */}

            <TabPanel value="3">
              <Gallery data={kioskImage} />
            </TabPanel>


            {/* =================================================
                TAB 4 - SKILL DEVELOPMENT
            ================================================= */}

            <TabPanel value="4">
              <Gallery data={skilldevelopmentImage} />
            </TabPanel>


            {/* =================================================
                TAB 5 - DIGITAL CONTENT
            ================================================= */}

            <TabPanel value="5">
              <Gallery data={digitalContent} />
            </TabPanel>


            {/* =================================================
                TAB 6 - AR / VR
            ================================================= */}

            <TabPanel value="6">
              <Gallery data={ARVR} />
            </TabPanel>


          </TabContext>

        </Box>

      </div>


      {/* =====================================================
          IMAGE MODAL
      ===================================================== */}

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 1, sm: 0 },
        }}
      >

        <ModalRoot>

          <img
            src={selectedImg}
            alt="Selected"
            style={{
              width: "100%",
              maxHeight: width < 700 ? "70vh" : "80vh",
              objectFit: "contain",
            }}
          />


          <Button
            fullWidth
            variant="contained"
            onClick={handleClose}
            style={{
              borderRadius: 0,
              backgroundColor: Colors.MAIN_COLOR,
            }}
          >
            Close
          </Button>

        </ModalRoot>

      </Modal>


      {/* FOOTER */}

      <Footer />

    </div>
  );
}